import React from "react"
import styled from "styled-components"

const ListItem = styled.li`
  padding: 0.25rem 0;
`

const SubList = styled.ul`
  padding-left: 1.5rem;
`

const Heading = styled.h2`
  margin: 1rem 0 0.5rem;
`

const Paragraph = styled.p`
  margin: 0.5rem 0;
`

const TermsAndConditions = () => {
  const companyName = process.env.GATSBY_COMPANY_NAME || "Bradbury"
  const companyRegisteredName = `${companyName} (Pty) Ltd`
  const companyEmail = process.env.GATSBY_COMPANY_EMAIL || "management@bradburyfin.co.za"
  const productName = process.env.GATSBY_PRODUCT_NAME || "Access Your Money"
  const productType = "Service"
  const companyNumber = process.env.GATSBY_COMPANY_CONTACT_NUMBER || "+27 87 551 1434"
  const companyRegNum = process.env.GATSBY_COMPANY_REG_NUM || "2020/523708/07"
  const companyAddress =
    process.env.GATSBY_COMPANY_ADDRESS ||
    "Bradbury House, 31A Bright Street, Somerset West"
  const companyWebsite = process.env.GATSBY_COMPANY_WEBSITE || "bradburyfin.co.za"

  return (
    <div>
      <ol>
        <ListItem>
          <Heading>Introduction</Heading>
          <Paragraph>
            Your Employer has selected <strong>{productName}</strong> as the
            Early Earned Wage Access solution for its employees. These Terms
            and Conditions govern your use of the <strong>{productName}</strong>{" "}
            platform. By accessing and using the platform, you acknowledge and
            agree to be bound by these Terms and Conditions.
          </Paragraph>
        </ListItem>

        <ListItem>
          <Heading>Purpose and Overview</Heading>
          <Paragraph>
            <strong>2.1</strong> Your Employer recognises that employees may
            face financial emergencies requiring early access to a portion of
            their earned salary or wage before the regular payday.
          </Paragraph>
          <Paragraph>
            <strong>2.2</strong> To provide a wellness benefit enabling such
            access, your Employer provides the <strong>{productName}</strong>{" "}
            platform as an Early Earned Wage Access solution and has appointed
            the Company as its agent and service provider to render the Early
            Earned Wage Access services on the Employer&apos;s behalf.
          </Paragraph>
          <Paragraph>
            <strong>2.3</strong> By using this Service, you acknowledge and
            agree that:
          </Paragraph>
          <SubList>
            <ListItem>
              <strong>2.3.1</strong> You may receive a portion of your already
              earned wages prior to the normal payday in terms of your
              employment agreement (the &ldquo;Accessed Portion&rdquo;).
            </ListItem>
            <ListItem>
              <strong>2.3.2</strong> By requesting early access to your earned
              wages, a transaction fee will become payable by you. You will be
              shown the exact transaction fee before proceeding and you must
              approve it to continue with an Earned Wage Access application.
            </ListItem>
            <ListItem>
              <strong>2.3.3</strong> Both the Accessed Portion and the approved
              transaction fee will be deducted by your Employer from your
              normal remuneration on the next normal payday.
            </ListItem>
          </SubList>
        </ListItem>

        <ListItem>
          <Heading>Definitions and General Information</Heading>
          <Paragraph>
            <strong>3.1 Definitions</strong>
          </Paragraph>
          <SubList>
            <ListItem>
              <strong>Access Point:</strong> includes, without limitation, a
              web-based portal and USSD.
            </ListItem>
            <ListItem>
              <strong>Accessed Portion:</strong> the portion of your salary or
              wage paid to you before the normal payday pursuant to a
              successful application on <strong>{productName}</strong>.
            </ListItem>
            <ListItem>
              <strong>Company / We / Us / Our:</strong>{" "}
              {companyRegisteredName}.
            </ListItem>
            <ListItem>
              <strong>Early Earned Wage Access:</strong> a FinTech solution
              that allows employees to access a portion of their already earned
              salary or wage prior to their regular payday.
            </ListItem>
            <ListItem>
              <strong>Employer:</strong> the entity with whom you concluded
              your employment agreement.
            </ListItem>
            <ListItem>
              <strong>Nominated Account:</strong> the same bank account or
              e-wallet used by your Employer to pay your salary or wage on
              payday.
            </ListItem>
            <ListItem>
              <strong>Payday:</strong> the day on which the Employer normally
              pays salaries and/or wages.
            </ListItem>
            <ListItem>
              <strong>Rules:</strong> the Employer-determined rules subject to
              which the Services are made available to you.
            </ListItem>
            <ListItem>
              <strong>Service:</strong> payment of a portion of your already
              earned salary or wage prior to the normal payday by the Company
              on behalf of the Employer, with subsequent deduction of the
              Accessed Portion and transaction fee from your remuneration on
              the next payday by the Employer.
            </ListItem>
            <ListItem>
              <strong>Transaction Fee:</strong> the fee you accept as part of
              an application for Early Earned Wage Access on{" "}
              <strong>{productName}</strong>.
            </ListItem>
            <ListItem>
              <strong>User / You / Your:</strong> the individual using the
              Services through <strong>{productName}</strong>.
            </ListItem>
            <ListItem>
              <strong>USSD:</strong> Unstructured Supplementary Service Data, a
              global communications protocol accessed via mobile device.
            </ListItem>
          </SubList>

          <Paragraph>
            <strong>3.2 Company and Product Information</strong>
          </Paragraph>
          <SubList>
            <ListItem>
              <strong>Product Name:</strong> {productName}
            </ListItem>
            <ListItem>
              <strong>Company Name:</strong> {companyRegisteredName}
            </ListItem>
            <ListItem>
              <strong>Registration Number:</strong> {companyRegNum}
            </ListItem>
            <ListItem>
              <strong>Physical Address:</strong> {companyAddress}
            </ListItem>
            <ListItem>
              <strong>Telephone:</strong> {companyNumber}
            </ListItem>
            <ListItem>
              <strong>Email Address:</strong> {companyEmail}
            </ListItem>
            <ListItem>
              <strong>Website:</strong> {companyWebsite}
            </ListItem>
          </SubList>
        </ListItem>

        <ListItem>
          <Heading>User Rights and Obligations</Heading>
          <Paragraph>
            <strong>4.1 Applications and Fees</strong>
          </Paragraph>
          <Paragraph>
            You will be shown the specific transaction fee payable if your
            application is approved and you must agree to it before your
            application can be finalised.
          </Paragraph>
          <Paragraph>
            If your application is approved and the Accessed Portion is paid to
            your Nominated Account, you become liable for payment of the
            transaction fee together with repayment of the Accessed Portion on
            the next payday.
          </Paragraph>
          <Paragraph>
            You irrevocably authorise your Employer to deduct the Accessed
            Portion and the relevant transaction fee from your salary or wage
            on the next payday.
          </Paragraph>

          <Paragraph>
            <strong>4.2 Payments and Accounts</strong>
          </Paragraph>
          <Paragraph>
            All Accessed Portion payments are made only into the Nominated
            Account. It is your responsibility to ensure your Employer has your
            updated banking particulars. No payments will be made to third
            parties or to accounts other than the Nominated Account.
          </Paragraph>

          <Paragraph>
            <strong>4.3 Assignment</strong>
          </Paragraph>
          <Paragraph>
            You may not cede or assign any rights or obligations under these
            Terms and Conditions without the prior written permission of the
            Company.
          </Paragraph>

          <Paragraph>
            <strong>4.4 Consent to Processing</strong>
          </Paragraph>
          <Paragraph>
            You consent to the processing of your personal information for the
            purpose of enabling us to provide the Services to you.
          </Paragraph>

          <Paragraph>
            <strong>4.5 Irrevocability</strong>
          </Paragraph>
          <Paragraph>
            Each application for Early Earned Wage Access submitted by you on{" "}
            <strong>{productName}</strong> is irrevocable and cannot be
            cancelled after submission.
          </Paragraph>

          <Paragraph>
            <strong>4.6 Resignation</strong>
          </Paragraph>
          <Paragraph>
            If you resign after receiving an Accessed Portion, your Employer
            shall deduct the Accessed Portion and the relevant transaction fee
            from your final remuneration payment, and you irrevocably
            authorise such deduction.
          </Paragraph>
        </ListItem>

        <ListItem>
          <Heading>Employer Rights and Responsibilities</Heading>
          <Paragraph>
            The Services are made available solely on your Employer&apos;s
            instructions, and your Employer may suspend the Services at any
            time, in whole or for specific employees.
          </Paragraph>
          <Paragraph>
            Your Employer sets the Rules which apply to the Services; your use
            of the Services is subject to those Rules.
          </Paragraph>
          <Paragraph>
            Your Employer may set payment limits. We are not authorised to
            provide any Service if the requested amount exceeds Employer-set
            limits.
          </Paragraph>
          <Paragraph>
            Your Employer shall deduct the Accessed Portion and the relevant
            transaction fee from your salary or wage on the next payday
            following payment of an Accessed Portion to you by us.
          </Paragraph>
        </ListItem>

        <ListItem>
          <Heading>Company Responsibilities</Heading>
          <Paragraph>
            Where your application has been approved, the Company will make
            payment of the Accessed Portion within 24 (twenty four) hours after
            submission on <strong>{productName}</strong>.
          </Paragraph>
          <Paragraph>
            Payment into your Nominated Account as communicated by your
            Employer discharges the Company&apos;s obligation to you through
            performance.
          </Paragraph>
          <Paragraph>
            You will be able to access on <strong>{productName}</strong> a
            report of all transactions initiated by you, showing Accessed
            Portions and transaction fees for a period of three (3) years.
          </Paragraph>
        </ListItem>

        <ListItem>
          <Heading>Data Handling and User Consent</Heading>
          <Paragraph>
            <strong>7.1 Personal Information</strong>
          </Paragraph>
          <Paragraph>
            To provide the Services we process certain personal information,
            including (without limitation) employment particulars, contact
            details, remuneration details and banking account details.
          </Paragraph>

          <Paragraph>
            <strong>7.2 Processing Purposes</strong>
          </Paragraph>
          <SubList>
            <ListItem>
              Determining your credit record via duly authorised credit
              bureaus;
            </ListItem>
            <ListItem>
              Sharing with our third-party service providers to enable us to
              provide the Services;
            </ListItem>
            <ListItem>
              Marketing campaigns based on aggregated and anonymised
              transaction data.
            </ListItem>
          </SubList>

          <Paragraph>
            <strong>7.3 Consent</strong>
          </Paragraph>
          <Paragraph>
            By using <strong>{productName}</strong> you consent to our
            processing of your personal information for the purposes above and
            you grant us irrevocable consent to check your credit record with
            registered/authorised credit bureaus prior to approval of any
            application.
          </Paragraph>
          <Paragraph>
            All personal information is processed in accordance with applicable
            South African law, including POPIA and the Electronic
            Communications and Transactions Act (ECTA), and protected by
            reasonable cybersecurity measures to prevent unauthorised access.
            See our Privacy Policy on {companyWebsite}.
          </Paragraph>
        </ListItem>

        <ListItem>
          <Heading>Requests and Disputes</Heading>
          <Paragraph>
            <strong>8.1 Service Discretion</strong>
          </Paragraph>
          <Paragraph>
            We provide the Services solely on your Employer&apos;s instructions
            and may terminate the Services if our mandate from your Employer is
            terminated.
          </Paragraph>

          <Paragraph>
            <strong>8.2 Disputes</strong>
          </Paragraph>
          <Paragraph>
            You may dispute a transaction. Records of your transactions are
            available on the platform as set out in Clause 6.
          </Paragraph>
        </ListItem>

        <ListItem>
          <Heading>Section 43 Compliance (ECTA)</Heading>
          <SubList>
            <ListItem>
              <strong>Registered Name:</strong> {companyRegisteredName}
            </ListItem>
            <ListItem>
              <strong>Registration Number:</strong> {companyRegNum}
            </ListItem>
            <ListItem>
              <strong>Product Name:</strong> {productName}
            </ListItem>
            <ListItem>
              <strong>Product Type:</strong> {productType}
            </ListItem>
            <ListItem>
              <strong>Physical Address:</strong> {companyAddress}
            </ListItem>
            <ListItem>
              <strong>Telephone number:</strong> {companyNumber}
            </ListItem>
            <ListItem>
              <strong>E-mail address:</strong> {companyEmail}
            </ListItem>
            <ListItem>
              <strong>Website:</strong> {companyWebsite}
            </ListItem>
          </SubList>
          <Paragraph>
            The Company is not a member of any self-regulatory body and does
            not subscribe to a particular code of conduct.
          </Paragraph>
          <Paragraph>
            All data shared by your Employer with us is communicated through an
            encrypted channel and protected by reasonable cybersecurity
            measures.
          </Paragraph>
          <Paragraph>
            Other prescribed information is set out throughout these Terms and
            Conditions.
          </Paragraph>
        </ListItem>

        <ListItem>
          <Heading>Legal Terms</Heading>
          <Paragraph>
            <strong>10.1 Entire Agreement</strong>
          </Paragraph>
          <Paragraph>
            These Terms constitute the entire agreement between the Company and
            the User regarding the Services.
          </Paragraph>

          <Paragraph>
            <strong>10.2 Changes to Terms</strong>
          </Paragraph>
          <Paragraph>
            We may modify these Terms from time to time. Updated Terms will be
            posted on {companyWebsite}.
          </Paragraph>

          <Paragraph>
            <strong>10.3 Severability</strong>
          </Paragraph>
          <Paragraph>
            If any provision of these Terms is found to be void or
            unenforceable, the remaining provisions will remain in full force
            and effect.
          </Paragraph>

          <Paragraph>
            <strong>10.4 Governing Law</strong>
          </Paragraph>
          <Paragraph>
            These Terms and Conditions are governed by the laws of the Republic
            of South Africa.
          </Paragraph>
        </ListItem>

        <ListItem>
          <Heading>Contact Information</Heading>
          <Paragraph>
            See Clause 3.2 for the Company&apos;s registered details, address,
            website, email and telephone number.
          </Paragraph>
        </ListItem>
      </ol>
    </div>
  )
}

export default TermsAndConditions
